import * as React from "react";

import { UserFormPermissions } from "@simplyk/common";

import { DASHBOARD_PAGE_TRANSLATION_FILES } from "../../../../common/helpers/translationFiles";
import { TunnelLayout } from "../../../../common/layouts/Tunnel/TunnelLayout";

import { AppDashboardProvider } from "@/components/AppProvider/AppDashboardProvider/AppDashboardProvider";
import { DashboardHead } from "@/components/Head/DashboardHead";
import { DonationLiveFormEditorContainer } from "@/features/LiveFormEditor/DonationLiveFormEditorContainer";

const DonationFormsNew = () => {
  return <DonationLiveFormEditorContainer />;
};

const DonationFormsNewLayout = (page: React.ReactElement<unknown>): React.ReactNode => {
  return (
    <>
      {/* Nothing should wrap or block the Head component */}
      <DashboardHead />
      <AppDashboardProvider formPermissions={[UserFormPermissions.EditForm]}>
        <TunnelLayout noScreenPadding>{page}</TunnelLayout>
      </AppDashboardProvider>
    </>
  );
};

DonationFormsNew.getLayout = DonationFormsNewLayout;

DonationFormsNew.translationNamespaces = DASHBOARD_PAGE_TRANSLATION_FILES;

export default DonationFormsNew;
